import { Card, Input, Typography, Space, Button, Tag } from "antd";
import { PlusOutlined, MailOutlined } from "@ant-design/icons";
import { useState } from "react";
import { toastError, toastWarning } from "../../utils/toast";

const { Text, Title } = Typography;

interface EmailListSettingCardProps {
  title: string;
  description?: string;
  value: string[];
  onChange: (emails: string[]) => void;
  onSave: () => void;
  isDirty: boolean;
}

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EmailListSettingCard: React.FC<EmailListSettingCardProps> = ({
  title,
  description,
  value,
  onChange,
  onSave,
  isDirty,
}) => {
  const [input, setInput] = useState("");

  const addEmail = () => {
    const email = input.trim().toLowerCase();

    if (!emailRegex.test(email)) {
      toastError("Please enter a valid email address");
      return;
    }

    if (value.includes(email)) {
      toastWarning("Email already added");
      return;
    }

    onChange([...value, email]);
    setInput("");
  };

  const removeEmail = (email: string) => {
    onChange(value.filter((e) => e !== email));
  };

  return (
    <Card
      style={{ borderRadius: 12 }}
      styles={{ body: { padding: "20px 24px" } }}
    >
      <Space direction="vertical" size={14} style={{ width: "100%" }}>
        <div>
          <Title level={5} style={{ margin: 0 }}>
            {title}
          </Title>
          {description && (
            <Text type="secondary" style={{ fontSize: 13, marginTop: 2 }}>
              {description}
            </Text>
          )}
        </div>

        <Input
          size="large"
          prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
          placeholder="Enter email address and press Add"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onPressEnter={addEmail}
          suffix={
            <Button
              type="primary"
              size="small"
              icon={<PlusOutlined />}
              onClick={addEmail}
            >
              Add
            </Button>
          }
        />

        {value.length > 0 && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 6,
              padding: "8px 12px",
              background: "#f8fafc",
              borderRadius: 8,
              border: "1px solid #e2e8f0",
            }}
          >
            {value.map((email) => (
              <Tag
                key={email}
                closable
                onClose={() => removeEmail(email)}
                style={{
                  borderRadius: 6,
                  padding: "2px 10px",
                  fontSize: 13,
                }}
              >
                {email}
              </Tag>
            ))}
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button type="primary" onClick={onSave} disabled={!isDirty}>
            Save Changes
          </Button>
        </div>
      </Space>
    </Card>
  );
};
